var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rainbow entryBtn mb-4",on:{"click":_vm.click}},[_c('div',{staticClass:"entryBtn_icon"}),_c('div',{staticClass:"entryBtn_value"},[_vm._v(_vm._s(_vm.label))]),_c('m-icon',{staticClass:"entryBtn_right",attrs:{"type":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }